import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=fe3b5f88"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe3b5f88')) {
      api.createRecord('fe3b5f88', component.options)
    } else {
      api.reload('fe3b5f88', component.options)
    }
    module.hot.accept("./Contacts.vue?vue&type=template&id=fe3b5f88", function () {
      api.rerender('fe3b5f88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/Contacts.vue"
export default component.exports